// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2kAA5","tab":"Tabs_tab__zYpwd","tabActive":"Tabs_tabActive__1ciXf"};